<form
  [formGroup]="sigiForm"
  (ngSubmit)="onSubmit()"
  class="flex flex-col gap-4 sm:w-56">

  @if (loading) {
    <p>
      {{ 'common.messages.info.loading-sigi-files' | translateSafe }}
    </p>
  } @else if (sigiFiles.length > 0) {
    <p-listbox
      formControlName="sigiFile"
      [options]="sigiFiles"
      [filter]="true"
      optionLabel="label"
      optionValue="value"
      [multiple]="false"
      [metaKeySelection]="false"
      scrollHeight="250px"
      [striped]="true"
      class="w-full md:w-56" />
  } @else {
    <p>
      {{ 'common.messages.info.no-sigi-files' | translateSafe }}
    </p>
  }

  <app-input-submit [formData]="submitConfig" />
</form>
